// extracted by mini-css-extract-plugin
export default {"dropzone":"styles_dropzone__W47vL","active":"styles_active__Zcd9S","wrapper":"styles_wrapper__gW03B","body":"styles_body__4c5Zo"};